import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { trustedDevices, pathKey, consent_management } from "../constants/static";

export const AuthorizeReturn: FC = () => {
  const navigate = useNavigate();
  const path = sessionStorage.getItem(pathKey) || "";

  useEffect(() => {
    if (path.includes("legal")) {
      setTimeout(() => navigate("/legal/"), 0);
      sessionStorage.setItem(pathKey, "");
      return;
    } else if (path.includes(consent_management)) {
      setTimeout(() => navigate(`/${consent_management}/`), 0);
      sessionStorage.setItem(pathKey, "");
      return;
    } else {
      setTimeout(() => navigate(`/${trustedDevices}/`), 0);
      sessionStorage.setItem(pathKey, "");
    }
  }, []);
  return <div />;
};
